import axios from 'axios';
// import { serverErrorNotification } from './message';
import {requestCanceller} from './axiosCancelToken'

axios.defaults.headers.post['Content-Type'] = 'application/json';


axios.interceptors.request.use((config)=>{
    let token = localStorage.getItem('token');
    config.headers.Authorization =  token ? `Bearer ${token}` : '';
    return config;
})
axios.interceptors.response.use(null, error => {
    const expectedError =
        error.response &&
        error.response.status >= 400 &&
        error.response.status < 500;
        if (!expectedError && !requestCanceller().isCancel(error)) {
            // let eee= error;
            if(String(error.response.data).includes('File too large'))
            alert('خطا ! حجم عکس زیاد است')
            else
            alert('خطا در برقراری ارتباط با سرور')
        // serverErrorNotification(`خطا در برقراری ارتباط با سرور`);
        // console.log('خطا در بر قراری ارتباط با سرور');
    }
    return Promise.reject(error);
});
const http = {
    get: axios.get,
    post: axios.post,
    patch: axios.patch,
    delete: axios.delete
};
export default http;
